// Main Components
import * as React from "react"
// scss
import "./thin_blurb.scss"

const ThinBlurb = ({...props }) => {
  return (
    <div className="thin-blurb d-flex flex-column justify-content-start">
        {props.boldBefore ? <h2><strong>{props.headlineBold}</strong>{props.headline}</h2>:null}
        {props.boldAfter ? <h2>{props.headline}<strong>{props.headlineBold}</strong></h2>:null}
        <p>{props.paragraphOne}</p>
        <p>{props.paragraphTwo}</p>
    </div>
  )
}

export default ThinBlurb
